import { API } from "@/lib/api";
import {
  ReadProjectStorePeriod,
  WriteProjectStorePeriod,
} from "@/types/projectStorePeriod";
import {
  APIService,
  FetchListRequest,
  SuccessFetchListResponse,
} from "@/services/api";

const ProjectService = new APIService<
  ReadProjectStorePeriod,
  WriteProjectStorePeriod
>(API.Projects);

const sortPeriods = (items: ReadProjectStorePeriod[]) =>
  items.map((item) => ({
    ...item,
    periods: [...item.periods].sort((a, b) => a.period.localeCompare(b.period)),
  }));

export const ProjectStorePeriodsService = {
  getList: async (
    projectId: string,
    fetchParams: FetchListRequest<ReadProjectStorePeriod>,
  ) => {
    const response = await ProjectService.getList<
      SuccessFetchListResponse<ReadProjectStorePeriod>
    >(fetchParams, `/${projectId}/stores-periods`);
    return {
      ...response,
      items: sortPeriods(response.items),
    };
  },

  patch: (projectId: string, values: WriteProjectStorePeriod) => {
    return ProjectService.patch(projectId, values, `stores-periods`);
  },
};
